import Vue from 'vue';
import config from '@/config/index';
export default {
    //列表页相关
    // 查询
    getDeviceParameterPage(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/function/page`,
            method: 'get',
            params
        })
    },
    // 新增功能参数
    addDeviceParameter(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/function/add`,
            method: 'post',
            data
        })
    },
    // 查询设备类型下的参数
    getDeviceParameterByType(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/function/getByDeviceType`,
            method: 'get',
            params
        })
    },
    // 查询设备系列下的参数
    getDeviceParameterBySeries(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/series/getFunctionList`,
            method: 'get',
            params
        })
    },
}